import { createApiRef } from '@backstage/core-plugin-api';
import type { DpsApi } from './DpsApiClient';

export const dpsApiRef = createApiRef<DpsApi>({
  id: 'plugin.dps.service',
});
